/** In-browser image editor + AI edit (media-editor). */
export const mediaEditor = {
  open: "Edit",
  openLabel: "Edit image",
  title: "Edit image",
  description: "Add text, crop for Instagram, adjust colors or describe an AI edit. The original is never overwritten: exports and AI edits are saved as new versions.",
  loading: "Loading the image…",
  loadFailed: "The image couldn't be loaded for editing.",
  canvas: "Image canvas",
  canvasHint: "Click a layer to select it, drag to move it, use the handles to resize or rotate. Every action is also available from the panels.",
  versionOf: "Version {{version}}",
  editedFrom: "Edited from version {{version}}",
  toolbar: {
    label: "Editor tools",
    undo: "Undo",
    redo: "Redo",
    rotateLeft: "Rotate left",
    rotateRight: "Rotate right",
    flipH: "Flip horizontally",
    flipV: "Flip vertically",
    shortcuts: "Keyboard shortcuts",
    zoom: "Zoom: {{value}}%",
  },
  shortcuts: {
    title: "Keyboard shortcuts",
    undo: "Undo",
    redo: "Redo",
    delete: "Delete the selected layer",
    nudge: "Move the selected layer (Shift: 10 px)",
    text: "Add a text layer",
    deselect: "Deselect",
  },
  tabs: { text: "Text", adjust: "Adjust", shapes: "Shapes", layers: "Layers", ai: "AI edit" },
  text: {
    add: "Add text",
    placeholder: "Type your text",
    defaultAr: "نص جديد",
    defaultEn: "New text",
    content: "Text",
    font: "Font",
    weight: "Weight",
    weights: { "400": "Regular", "500": "Medium", "600": "Semibold", "700": "Bold" },
    size: "Size",
    color: "Color",
    swatches: "Brand colors",
    swatch: "Use {{color}}",
    align: "Alignment",
    alignLeft: "Left",
    alignCenter: "Center",
    alignRight: "Right",
    direction: "Direction",
    rtl: "Right to left",
    ltr: "Left to right",
    background: "Background box",
    backgroundColor: "Box color",
    outline: "Outline",
    outlineColor: "Outline color",
    outlineWidth: "Outline width",
    shadow: "Shadow",
    opacity: "Opacity",
    selectHint: "Add a text layer, or select one on the image or in Layers.",
  },
  adjust: {
    crop: "Crop for Instagram",
    ratios: { original: "Original", free: "Free", "1:1": "1:1 square", "4:5": "4:5 portrait", "1.91:1": "1.91:1 landscape", "9:16": "9:16 story" },
    brightness: "Brightness",
    contrast: "Contrast",
    saturation: "Saturation",
    reset: "Reset adjustments",
    output: "Output: {{w}} × {{h}} px",
  },
  shapes: {
    rect: "Rectangle",
    ellipse: "Ellipse",
    stickers: "Stickers",
    sticker: "Add {{emoji}}",
    fill: "Fill",
    selectHint: "Select a shape to change its color.",
  },
  layers: {
    empty: "No layers yet. Add text, a shape or a sticker.",
    select: "Select {{name}}",
    up: "Move up",
    down: "Move down",
    hide: "Hide",
    show: "Show",
    remove: "Delete layer",
    kinds: { text: "Text", rect: "Rectangle", ellipse: "Ellipse", sticker: "Sticker" },
  },
  ai: {
    title: "Describe the change",
    hint: "The AI edits the original image. Optionally paint the area to change; your text and shapes stay on top.",
    placeholder: "e.g. make the background a sunset beach",
    paint: "Paint the area to change",
    brush: "Brush size",
    clearMask: "Clear painted area",
    run: "Apply AI edit",
    running: "Editing with AI…",
    queued: "AI edit started. You can keep editing or leave: we'll notify you when it's ready.",
    done: "The AI edit is ready: opened as a new version.",
    failed: "The AI edit failed.",
    maskHint_one: "Painted strokes: {{count}}",
    maskHint_other: "Painted strokes: {{count}}",
  },
  export: {
    button: "Export",
    png: "PNG (lossless)",
    jpeg: "JPEG (smaller)",
    format: "Format",
    saving: "Saving…",
    saved: "Saved to the media library as version {{version}}",
    failed: "Export failed. Try again.",
    usePost: "Use in post",
    another: "Keep editing",
  },
  close: "Close editor",
  discardTitle: "Close the editor?",
  /** ALP-84: closing with edits that were not exported. */
  discard: {
    title: "Discard your edits?",
    hint: "You haven't exported them yet. The original image stays as it was.",
    confirm: "Discard edits",
  },
};
